'use client';
import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import Collapse from '@/components/atoms/collapse';
import { useSearchParams } from 'next/navigation';
import { clauseItems, policyItems, purchaseTermsItems } from './policy-data';

const PolicyModule = () => {
  const [activeTab, setActiveTab] = useState('1');
  const searchParams = useSearchParams();
  const tabName = searchParams?.get('policy_type');
  const items = [
    {
      key: 'chinh-sach-bao-ve',
      label: 'Chính sách bảo vệ dữ liệu cá nhân',
      children: <Policy />,
    },
    {
      key: 'dieu-khoan-dieu-kien-chung',
      label: 'Điều khoản và điều kiện chung',
      children: <Clause />,
    },
    {
      key: 'dieu-khoan-mua-goi-dich-vu',
      label: 'Điều khoản mua gói dịch vụ dữ liệu',
      children: <PurchaseTerms />,
    },
  ];
  useEffect(() => {
    if (tabName) {
      switch (tabName) {
        case 'chinh-sach-bao-ve':
          setActiveTab('chinh-sach-bao-ve');
          break;
        case 'dieu-khoan-dieu-kien-chung':
          setActiveTab('dieu-khoan-dieu-kien-chung');
          break;
        case 'dieu-khoan-mua-goi-dich-vu':
          setActiveTab('dieu-khoan-mua-goi-dich-vu');
          break;
        default:
          setActiveTab('dieu-khoan-dieu-kien-chung');
      }
    }
  }, [tabName]);
  const onChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <div className="p-policy">
      <div className="p-policy_wrapper">
        <Tabs activeKey={activeTab} items={items} onChange={onChange} />
      </div>
    </div>
  );
};

export default PolicyModule;

function Policy() {
  return (
    <>
      <div className="page-title">Chính sách bảo vệ dữ liệu cá nhân</div>
      <div className="p-policy_content">
        <p>
          Công Ty TNHH tư vấn chiến lược chính sách và phân tích dữ liệu kinh tế
          (sau đây gọi “Vietstats”) là công ty chuyên về dịch vụ tổng hợp và
          phân tích dữ liệu kinh tế Việt Nam, tư vấn chiến lược chính sách. Bằng
          việc cung cấp Chính Sách Bảo Vệ Dữ Liệu Cá Nhân (sau đây gọi tắt
          “Chính Sách”), Vietstats hi vọng có thể giúp Khách hàng hiểu rõ mục
          đích và cách thức mà Vietstats thu thập, lưu trữ, xử lý dữ liệu cá
          nhân của Khách hàng thông qua Website. Khi Khách hàng truy cập và sử
          dụng Website (bao gồm cả việc đăng ký và mua sản phẩm/ sử dụng dịch
          vụ), chúng tôi hiểu rằng bạn hoàn toàn đồng ý với các điều khoản của
          chính sách này.{' '}
        </p>
        <Collapse items={policyItems} accordion={true} />
      </div>
    </>
  );
}

function Clause() {
  return (
    <>
      <div className="page-title">Điều khoản và điều kiện chung</div>
      <div className="p-policy_content">
        <p>
          Cảm ơn bạn đã truy cập vào website: Vietstats.vn (sau đây gọi
          “WEBSITE”) của Công Ty TNHH Tư vấn chiến lược chính sách và phân tích
          dữ liệu kinh tế Vietstats (sau đây gọi “Vietstats”). Vietstats tạo và
          duy trì WEBSITE nhằm mục đích cung cấp dịch vụ tổng hợp dữ liệu, giới
          thiệu sản phẩm được cung cấp bởi Vietstats. Bằng việc sử dụng WEBSITE,
          bạn được coi là đã chấp nhận và đồng ý bị ràng buộc bởi Điều kiện và
          điều khoản sử dụng này cũng như tuân thủ tất cả các quy định của pháp
          luật Việt Nam.
        </p>
        <Collapse items={clauseItems} accordion={true} />
      </div>
    </>
  );
}

function PurchaseTerms() {
  return (
    <>
      <div className="page-title">Điều khoản mua gói dịch vụ dữ liệu</div>
      <div className="p-policy_content">
        <p>
          Chúng tôi rất vui khi bạn quan tâm đến dịch vụ cung cấp Gói dữ liệu
          của Công ty TNHH Tư vấn chiến lược chính sách và phân tích dữ liệu
          kinh tế Vietstats (Sau đây gọi tắt “Vietstats”). Trước khi hoàn tất
          giao dịch, bạn vui lòng dành chút thời gian để đọc kỹ các điều khoản
          dưới đây. Việc thanh toán và sử dụng dịch vụ đồng nghĩa với việc bạn
          hiểu rõ quyền lợi, phạm vi sử dụng, trách nhiệm đi kèm và chấp thuận
          ràng buộc bởi các điều khoản dưới đây.
        </p>
        <Collapse items={purchaseTermsItems} accordion={true} />
      </div>
    </>
  );
}
